const AGE_BRACKETS = [
  '6-15 years',
  '16-17 years',
  '18-25 years',
  '26-35 years',
  '36-45 years',
  '46 years and above',
] as const;

type AgeBracket = (typeof AGE_BRACKETS)[number];

const LEGACY_AGE_LABELS: Record<string, AgeBracket> = {
  '< 18': '6-15 years',
  'Less than 18 years': '6-15 years',
  '18 - 24': '18-25 years',
  '18 - 29': '18-25 years',
  '18 - 29 years': '18-25 years',
  '25 - 29': '26-35 years',
  '30 - 44': '36-45 years',
  '30 - 44 years': '36-45 years',
  '45 >': '46 years and above',
  '45 - 59': '46 years and above',
  '60+': '46 years and above',
  'More than 45 years': '46 years and above',
};

export const formatAgeGroupForDisplay = (ageGroup?: string | null): string => {
  if (!ageGroup) {
    return 'N/A';
  }

  const normalized = ageGroup.trim();

  if ((AGE_BRACKETS as readonly string[]).includes(normalized)) {
    return normalized;
  }

  return LEGACY_AGE_LABELS[normalized] ?? normalized;
};
